import { render, staticRenderFns } from "./MPopupLogoList.vue?vue&type=template&id=5395ecd2&"
import script from "./MPopupLogoList.ts?vue&type=script&lang=ts&"
export * from "./MPopupLogoList.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports